"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculate_basket_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var basket_1 = require("../basket");
var calculateBasketDiscountDeals = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var DELIVERYDEAL, APPLY_TO_BASKET, _i, _a, deal;
    return __generator(this, function (_b) {
        DELIVERYDEAL = "FREE-SHIPPING";
        APPLY_TO_BASKET = "BASKET";
        response.content["has_delivery_fee_deal"] = false;
        for (_i = 0, _a = response.content.deals; _i < _a.length; _i++) {
            deal = _a[_i];
            if (deal.delivery_fee && deal.apply_to == APPLY_TO_BASKET) {
                // change the delivery fee to be the discount delivery fee
                response.content["delivery_fee_deal"] = deal.delivery_fee;
                response.content["has_delivery_fee_deal"] = true;
            }
        }
        return [2 /*return*/, response];
    });
}); };
var calculateTotalProductDiscountDeals = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var dealTotal, index, product, deal;
    return __generator(this, function (_a) {
        if (response.content.product_list.length != 0) {
            dealTotal = 0;
            for (index = 0; index < response.content.product_list.length; index++) {
                product = response.content.product_list[index];
                if (product === null || product === void 0 ? void 0 : product.deal) {
                    deal = product.deal;
                    dealTotal = +parseFloat(deal.discount);
                    return [2 /*return*/, dealTotal];
                }
            }
        }
        return [2 /*return*/, 0];
    });
}); };
exports.calculate_basket_thunk = (0, toolkit_1.createAsyncThunk)("basket/calculate_basket_thunk", function (response, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var basketResponse, dealTotal;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, calculateBasketDiscountDeals(response)];
                case 1:
                    basketResponse = _b.sent();
                    return [4 /*yield*/, calculateTotalProductDiscountDeals(basketResponse)];
                case 2:
                    dealTotal = _b.sent();
                    basketResponse.content["total_product_deals"] = dealTotal.toString();
                    dispatch((0, basket_1.setBasket)(basketResponse.content));
                    return [2 /*return*/, basketResponse];
            }
        });
    });
});
